import React, { useMemo } from 'react';
import type { WorkflowDsl } from '../../../types/workflow';
import { Banner } from './WorkflowFormControls';

export interface WorkflowDataPanelProps {
  dsl: WorkflowDsl | null;
  baseDigest: string | null;
  problems: string[];
  onExport: () => void;
  onImportClick: () => void;
}

const WorkflowDataPanel: React.FC<WorkflowDataPanelProps> = ({ dsl, baseDigest, problems, onExport, onImportClick }) => {
  const sizeKb = useMemo(() => (dsl ? Math.round(JSON.stringify(dsl).length / 1024) : 0), [dsl]);

  return (
    <div className="cwf-data">
      <p className="cwf-note">
        Validate the workflow and move a complete workflow file between environments. The editor handles the underlying
        data format automatically.
      </p>

      {problems.length ? <Banner tone="error" title="The graph cannot be saved yet" details={problems} /> : null}

      <div className="cwf-data-summary">
        <div><span>Base revision</span><strong>{baseDigest ? `${baseDigest.slice(0, 12)}…` : '—'}</strong></div>
        <div><span>States</span><strong>{dsl?.states.length ?? '—'}</strong></div>
        <div><span>Transitions</span><strong>{dsl?.transitions.length ?? '—'}</strong></div>
        <div><span>File size</span><strong>~{sizeKb} KB</strong></div>
      </div>

      <div className="cwf-inline">
        <button type="button" className="cwf-btn cwf-btn--sm" onClick={onExport} disabled={!dsl}>
          <i className="fas fa-download" aria-hidden="true" /> Export workflow file
        </button>
        <button type="button" className="cwf-btn cwf-btn--sm" onClick={onImportClick}>
          <i className="fas fa-upload" aria-hidden="true" /> Import workflow file…
        </button>
      </div>
    </div>
  );
};

export default WorkflowDataPanel;
